/**
 * 入力フォーム
 */
export default {
  state: {
    // 検索画面
    search: null
  },
  getters: {
    /**
     * 検索画面を取得
     */
    forms_search (state) {
      return state.search || {
        area1: null,
        area2: null,
        area3: null,
        areaData: null,
        dateFrom: null,
        dateTo: null,
        luggage: null
      }
    }
  },
  actions: {
  },
  mutations: {
    /**
     * 検索画面
     *
     * @param data 入力データ
     */
    forms_set_search (state, data) {
      state.search = data
    }
  }
}
